import React, { useEffect, useMemo, useState } from 'react';
import { avecPerimetre } from './perimetre';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useBi } from '../BiContext';
import TableauBord from './TableauBord';
import './Shell.css';

// Accueil-catalogue : les rapports de la branche courante, groupés par métier,
// avec recherche. La navigation fine (arbre) vit dans la sidebar persistante.
function Shell() {
  const { data, chargement, branche, setBranche } = useBi();
  const [recherche, setRecherche] = useState('');
  const navigate = useNavigate();
  const [params] = useSearchParams();

  // ?branche=… dans l'URL (lien partagé, retour de rapport) pilote le contexte.
  useEffect(() => {
    const b = params.get('branche');
    if (b && b !== branche && data.branches.some((x) => x.code === b)) setBranche(b);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, data.branches]);

  const brancheObj = data.branches.find((b) => b.code === branche);
  const nomMetier = (code) => data.metiers.find((m) => m.code === code)?.nom || code;

  const sections = useMemo(() => {
    if (!brancheObj) return [];
    const q = recherche.trim().toLowerCase();
    const visibles = data.rapports.filter((r) =>
      (r.branche_code === brancheObj.code || r.branche_code === null) &&
      (!q || r.titre.toLowerCase().includes(q) || (r.description || '').toLowerCase().includes(q))
    );
    return data.metiers
      .map((m) => ({ metier: m, rapports: visibles.filter((r) => r.metier_code === m.code) }))
      .filter((s) => s.rapports.length > 0);
  }, [data, brancheObj, recherche]);

  // Auto Antilles et Auto Métropole (2026-09-30) : l'accueil ne montre QUE le
  // tableau de bord, en pleine page ; les rapports s'ouvrent depuis le menu de
  // gauche. Les autres branches, sans tableau de bord, gardent le catalogue.
  // `key` : changer de branche repart d'un état vierge (sociétés différentes).
  if (brancheObj?.code === 'auto-antilles' || brancheObj?.code === 'auto-metropole') {
    return <TableauBord key={brancheObj.code} branche={brancheObj.code} />;
  }

  return (
    <main className="bi-content">
      <div className="bi-toolbar">
        <input
          className="bi-search"
          placeholder="🔍 Rechercher un rapport..."
          value={recherche}
          onChange={(e) => setRecherche(e.target.value)}
        />
        {brancheObj && <div className="bi-toolbar-context">{brancheObj.nom}</div>}
      </div>

      {chargement ? null : sections.length === 0 ? (
        <div className="bi-empty">
          <h2>{recherche ? 'Aucun rapport ne correspond' : 'Aucun rapport pour l\'instant'}</h2>
          <p>
            {recherche
              ? 'Essayez un autre terme de recherche.'
              : brancheObj
                ? `Les rapports de ${brancheObj.nom} apparaîtront ici dès que leurs sources de données seront branchées.`
                : 'Votre habilitation ne couvre encore aucune branche.'}
          </p>
        </div>
      ) : (
        sections.map(({ metier, rapports }) => (
          <section key={metier.code} className="bi-section">
            <h2 className="bi-section-title">{metier.nom}</h2>
            <div className="bi-grid">
              {rapports.map((r) => (
                <button key={r.id} className="bi-report-card" onClick={() => navigate(avecPerimetre(`/r/${r.slug}`, window.location.search))}>
                  <div className="bi-report-entite">
                    {nomMetier(r.metier_code)}
                    {r.branche_code === null && <span className="bi-report-commun"> · toutes branches</span>}
                  </div>
                  <h3>{r.titre}</h3>
                  {r.description && <p>{r.description}</p>}
                  <div className="bi-report-meta">
                    Mis à jour le {new Date(r.updated_at).toLocaleDateString('fr-FR')}
                  </div>
                </button>
              ))}
            </div>
          </section>
        ))
      )}
    </main>
  );
}

export default Shell;
